<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="170"
    offset-y
  >
    <template #activator="{ on }">
      <v-btn icon v-on="on">
        <v-avatar color="white" size="30">
          <v-img :src="$page.props.user.profile_photo_url" aspect-ratio="1" />
        </v-avatar>
      </v-btn>
    </template>

    <v-list>
      <v-list-item two-line>
        <v-list-item-avatar>
          <v-img :src="$page.props.user.profile_photo_url" aspect-ratio="1" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ $page.props.user.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $page.props.user.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar>
          <inertia-link
            v-if="$page.props.jetstream.canUpdatePassword || $page.props.jetstream.canUpdateProfileInformation || $page.props.jetstream.managesProfilePhotos || $page.props.jetstream.hasAccountDeletionFeatures"
            class="v-list-item v-list-item--link theme--light"
            :href="route('profile.show')"
            replace
            @click="menu = false"
          >
            <v-icon color="primary">
              mdi-account-edit
            </v-icon>
          </inertia-link>
        </v-list-item-avatar>
      </v-list-item>
      <v-divider />

      <inertia-link v-if="$page.props.jetstream.hasApiFeatures" class="v-list-item v-list-item--link theme--light" :href="route('api-tokens.index')" replace @click="menu = false">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-api
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>API Tokens</v-list-item-title>
      </inertia-link>
      <inertia-link class="v-list-item v-list-item--link theme--light" :href="route('logout')" method="post" replace>
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-exit-to-app
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>Logout</v-list-item-title>
      </inertia-link>
    </v-list>
  </v-menu>
</template>
<script>
export default {
   components: {
      //
   },

   data: () => ({
      menu: false,
      team: null
   }),

   created () {
      this.team = this.$page.props.user.current_team_id
   },

   methods: {
      hasPermission () {
         return true
      },
      switchTeam () {
         this.$inertia.put(this.route('current-team.update'), {
            team_id: this.team
         }, {
            preserveState: true
         })
      }
   }
}
</script>
